import { render, staticRenderFns } from "./BatchProductionModal.vue?vue&type=template&id=2f3ca846&scoped=true&"
import script from "./BatchProductionModal.vue?vue&type=script&lang=js&"
export * from "./BatchProductionModal.vue?vue&type=script&lang=js&"
import style0 from "./BatchProductionModal.vue?vue&type=style&index=0&id=2f3ca846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3ca846",
  null
  
)

export default component.exports